import { useCallback, useMemo } from 'react'
import { IPregnancy, ITimelineMaternalInfant } from '~/interfaces'
import { hasObjectValue } from '~/utils'

const MATERNAL_INFANT_VIEW_SETTINGS_KEY = 'maternalInfantViewSettings'

interface IMaternalInfantSettings {
  medicalRecord: string
  selectedPregnancy: IPregnancy
  selectedBaby: number | null
  selectedTimeline: ITimelineMaternalInfant.PatientType
}

interface IUseMaternalInfantViewSettings {
  getMaternalInfantViewSettings: () => IMaternalInfantSettings
  updateMaternalInfantViewSettings: (newSettings: IMaternalInfantSettings) => void
  thereAreMaternalInfantViewSettings: boolean
  cleanupMaternalInfantViewSettings: () => void
}

export const useMaternalInfantViewSettings = (): IUseMaternalInfantViewSettings => {
  const maternalInfantViewSettings = useMemo(
    () => JSON.parse(sessionStorage.getItem(MATERNAL_INFANT_VIEW_SETTINGS_KEY) ?? '{}') as IMaternalInfantSettings,
    []
  )

  const cleanupMaternalInfantViewSettings = useCallback(() => {
    sessionStorage.removeItem(MATERNAL_INFANT_VIEW_SETTINGS_KEY)
  }, [])

  const getMaternalInfantViewSettings = useCallback((): IMaternalInfantSettings => {
    return JSON.parse(sessionStorage.getItem(MATERNAL_INFANT_VIEW_SETTINGS_KEY) ?? '{}') as IMaternalInfantSettings
  }, [])

  const updateMaternalInfantViewSettings = useCallback((newSettings: IMaternalInfantSettings): void => {
    sessionStorage.setItem(MATERNAL_INFANT_VIEW_SETTINGS_KEY, JSON.stringify(newSettings))
  }, [])

  return {
    getMaternalInfantViewSettings,
    updateMaternalInfantViewSettings,
    thereAreMaternalInfantViewSettings: hasObjectValue({ ...maternalInfantViewSettings }),
    cleanupMaternalInfantViewSettings
  }
}
